import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '../Dialog';

const ProgressDialog = ({ isOpen, message }) => (
  <Dialog open={isOpen} maxWidth="xs">
    <DialogContent style={{ paddingBottom: 20 }}>
      <Box display="flex" alignItems="center">
        <Box mr={2}>
          <CircularProgress />
        </Box>
        {message}
      </Box>
    </DialogContent>
  </Dialog>
);

ProgressDialog.propTypes = {
  isOpen: PropTypes.bool,
  message: PropTypes.string,
};

ProgressDialog.defaultProps = {
  isOpen: false,
  message: PropTypes.string,
};

export default ProgressDialog;
